import React, {useState} from 'react';
import './App.css';
import FullApp from './apps/FullApp';
import PartialApp from './apps/PartialApp';
import portugueseIcon from './assets/portuguese.png'; 
import englishIcon from './assets/english.png'; 

const partialForms = 1;

function App() {
  const [language, setLanguage] = useState('en');

  const handleButtonClick = () => {
    if (language == 'en') {
      setLanguage('pt')
    }
    else{
      setLanguage('en')
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>TourHub</h1>
        <button className="language-button" onClick={handleButtonClick}>
          <img
            src={language === 'en' ? portugueseIcon : englishIcon}
            alt={language === 'en' ? 'Portuguese' : 'English'}
            className="button-icon"
          />
        </button>
      </header>
      {partialForms ? <PartialApp language={language}/> : <FullApp />}
    </div>
  );
}

export default App;
